<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('advertisers')">Anunciante</inertia-link>
      <span class="text-blue-400 font-medium">/</span> Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.usuario" :error="form.errors.usuario" class="pr-6 pb-8 w-full lg:w-1/2" label="Usuario" />
            <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.correo" :error="form.errors.correo" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
            <text-input v-model="form.fono" :error="form.errors.fono" class="pr-6 pb-8 w-full lg:w-1/2" label="Telefono" />
            <text-input v-model="form.senia" :error="form.errors.senia" class="pr-6 pb-8 w-full lg:w-1/2" label="Password?" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Anunciante</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'


export default {
  metaInfo: { title: 'Crear Anunciante' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        usuario: null,
        nombre: null,
        correo: null,
        fono: null,
        senia: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('advertisers.store'))
    },
  },
}
</script>
